import * as React from 'react';
import { useRouteMatch } from 'react-router';

import { EmbeddedGlobalStyles } from '~/AppGlobalStyles';
import { PrivateRoute } from '~/components/Auth';
import { EmbeddedView } from '~/scenes/EmbeddedViews/component';

type PropsType = {
  availableViews?: string[];
};

export const EmbeddedViewRouter = (props: PropsType) => {
  const { path } = useRouteMatch();
  const { availableViews } = props;

  // If availableViews are defined, paths are constrained to listed and wrong paths will show 404 page
  const fullRoute =
    availableViews && availableViews.length > 0
      ? `${path}/:embeddedView(${availableViews.join('|')})`
      : `${path}/:embeddedView`;

  return (
    <>
      <EmbeddedGlobalStyles />
      <PrivateRoute path={fullRoute} component={EmbeddedView} />
      <PrivateRoute exact path={path} render={() => <div>404 not found</div>} />
    </>
  );
};
